import { ReactNode } from 'react'

import { LIGHT_THEME_BACKGROUND } from '../../colors'
import { cn } from '../../ui/cn'

const PageContainer = ({
  children,
  darkModeEnabled,
  className,
  style: styleOverrides,
}: {
  children?: ReactNode
  darkModeEnabled?: boolean
  className?: string
  style?: React.CSSProperties
}) => {
  const style = {
    backgroundColor: darkModeEnabled ? 'transparent' : LIGHT_THEME_BACKGROUND,
    ...(styleOverrides || {}),
  } as React.CSSProperties

  return (
    <div
      style={style}
      className={cn(
        'flex min-h-full grow flex-col items-stretch justify-start text-text-primary',
        darkModeEnabled ? 'cool-svg-bg-1-dark' : 'cool-svg-bg-1-light',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default PageContainer
